import * as React from 'react';

export interface UseBhanzuBuddyGuideFlowProps {
  pendingGuideQuestionRef: React.RefObject<string>;
  currentMode: 'explain' | 'guide';
  currentSource: string;
  handleGuideFlow?: (question: string) => void;
  leadId?: string;
}

export const useBhanzuBuddyGuideFlow = ({
  pendingGuideQuestionRef,
  currentMode,
  currentSource,
  handleGuideFlow,
  leadId,
}: UseBhanzuBuddyGuideFlowProps) => {
  React.useEffect(() => {
    if (
      pendingGuideQuestionRef.current &&
      currentMode === 'guide' &&
      currentSource === 'guide_me' &&
      typeof handleGuideFlow === 'function' &&
      leadId
    ) {
      const question = pendingGuideQuestionRef.current;
      // Avoid returning a promise into useEffect; fire-and-forget
      void Promise.resolve().then(() => {
        handleGuideFlow(question);
      });
      pendingGuideQuestionRef.current = '';
    }
  }, [
    currentMode,
    currentSource,
    handleGuideFlow,
    leadId,
    pendingGuideQuestionRef,
  ]);
};
